<script>
export default {
  name: 'form-number-stepper',
  props: {
    value: { type: Number, default: 0 },
    unit: { type: Number, default: 1 },
    width: { type: String, default: '140px' },
    min: { type: Number },
    max: { type: Number }
  },
  data: () => ({
    val: 0
  }),
  watch: {
    value: {
      handler (v) {
        this.val = v
      },
      immediate: true
    },
    val: {
      handler (v, oldVal) {
        this.$emit('input', Math.round(v * 10) / 10)
      }
    }
  },
  methods: {
    onAdd () {
      if ((this.max !== undefined || this.max !== null) && this.val >= this.max)
        return
      this.val = this.val + this.unit
    },
    onSubtract () {
      if ((this.min !== undefined || this.min !== null) && this.val <= this.min)
        return
      this.val = this.val - this.unit
    }
  }
}
</script>
<template>
  <b-input-group :style="{ width }">
    <b-input-group-prepend>
      <b-btn
        v-on:click="onSubtract"
        class="px-2 mx-0"
        :disabled="$attrs.disabled"
        :variant="$attrs.disabled ? 'light' : 'primary'"
      >
        <i class="fa fa-minus"></i>
      </b-btn>
    </b-input-group-prepend>
    <b-form-input
      v-bind="$attrs"
      v-model.number="val"
      required
      class="text-center"
    />

    <b-input-group-append>
      <b-btn
        v-on:click="onAdd"
        class="px-2 mx-0"
        :disabled="$attrs.disabled"
        :variant="$attrs.disabled ? 'light' : 'primary'"
      >
        <i class="fa fa-plus"></i>
      </b-btn>
    </b-input-group-append>
  </b-input-group>
</template>
